import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import useSeoData from '../hooks/useSeoData';
const SeoLanding: React.FC = () => {
const {title,description,keyboard,author,image,logo}=useSeoData()

  return (
      <Helmet>
        {/* SEO Meta Tags */}
        <meta charSet="utf-8" />
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={description} />
        <meta name="author" content="Efes Kebab" />

        {/* Open Graph Tags (For Facebook, WhatsApp, LinkedIn, etc.) */}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={image} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        {/* <meta property="og:url" content="https://efeskebabportsmouth.co.uk/about" /> */}
        <meta property="og:type" content="website" />

        {/* Twitter Card Tags */}
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={image} />
        {/* <meta name="twitter:card" content="summary_large_image" /> */}

        {/* Site Logo (For general branding purposes) */}
        <link rel="icon" href={logo} type="image/png" />
      </Helmet>
      
  );
};

export default SeoLanding;
